import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const submitPurchaseReceiveReducer = (state = "", action) => {
  const actionName = serverApis.submitPurchaseReceive.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.result;

    case getResetAction(actionName):
      return "";
    default:
      return state;
  }
};
